import { jsx as e } from "@emotion/react/jsx-runtime";
import { OuterPreviewContainer as t } from "./OuterPreview.styled.js";
const n = ({
  children: r
}) => /* @__PURE__ */ e(t, { gap: "8px", direction: "column", style: {
  flex: 1
}, children: r });
export {
  n as OuterPreview
};
